import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

const DeliveryManagerApi = {
    presetMemoList: '/delivery/memo/v2',
    presetMemo: '/delivery/memo',
}

const api = getApi(getCommonBaseUrl())

const getPresetMemoList = () => {
    return createWrapper<SchemasUniversalDelivery['/delivery/memo/v2']['response']>(
        api.get(DeliveryManagerApi.presetMemoList),
    )
}

const deletePresetMemo = ({memoSeqs}: {memoSeqs: number[]}) => {
    return createWrapper<SchemasUniversalDelivery['DELETE/delivery/memo']['response']>(
        api.delete(DeliveryManagerApi.presetMemo, {data: {memoSeqs}}),
    )
}

export default {getPresetMemoList, deletePresetMemo}
